module.exports = __webpack_public_path__ + "img/Tablero-demo.80464893.svg";